import axios from 'axios'
import qs from 'qs'

export function get(url, params){
  return new Promise((resolve, reject) =>{
      axios.get(url, {
          params: params
      }).then(res => {
          resolve(res.data);
      }).catch(err =>{
          reject(err.data)
      })
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
      let jsona = JSON.parse(JSON.stringify(params));
       axios.post(url, jsona)
      .then(res => {
          resolve(res.data);
      })
      .catch(err =>{
          reject(err.data)
      })
  });
}

export const dict = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

export function getIndex(sd) {
  let rindex = undefined;
  dict.forEach((ele, index) => {
    if (ele === sd) {
      rindex = index;
    }
  })
  return rindex;
}

export function getIndexM(index) {
  return dict[index];
}

export function addSign(ssubjA) {
  ssubjA.forEach(ele => {
    Object.assign(ele, {
      clicked: false,
      result: false,
      perScore: 20,
      list: []
    })
  })
  return ssubjA;
}

export function getScore(objArr) {
  let score = 0;
  objArr.forEach(obj => {
    if (obj.clicked && obj.result) {
      score += obj.perScore;
    }
  })
  return score;
}

export function updateObj(objArr, oindex, attrObj) {
  let changedObj = objArr[oindex];
  changedObj ? Object.assign(changedObj, attrObj) : null
  return objArr;
}

export function isDone(objArr) {
  let isDone = true;
  for(let i = 0; i < objArr.length; i++) {
    if (!objArr[i].clicked) {
      isDone = false;
      break;
    }
  }
  return isDone;
}

export function ifAllRight(objArr) {
  let isAllRight = true;
  for (let i =  0; i < objArr.length; i++) {
    if(!objArr[i].result) {
      isAllRight = false;
      break;
    }
  }
  return isAllRight;
}

export function getRatio() {
  const ratio = window.devicePixelRatio;
  if (!!ratio && ratio >=3) {
    return 3;
  } else {
    return 2;
  }
}

export function dealUrl(urlParams) {
  // 获取的url的方式：locaction.search
  let theRequest = new Object();
  if (urlParams.indexOf("?") != -1) {
    let str = urlParams.substr(1);
    let strs = str.split("&");
    for(let i = 0; i < strs.length; i ++) {
        theRequest[strs[i].split("=")[0]]=(strs[i].substr(strs[i].indexOf('=')+1));
    }
  }
  console.log(theRequest)
  return theRequest;
}

export function dealMainTable (objArr) {
  let rarray = []
  let options = ['optionA', 'optionB', 'optionC', 'optionD', 'optionE', 'optionF', 'optionG'];
  objArr.forEach((objA, index) => {
    let tmp = {
      soptionsArr: []
    }
    options.forEach((objo, index1) => {
      if(objA[objo]) {
        tmp.soptionsArr.push(objA[objo])
      }
    })
    tmp.subject = objA.subjects
    tmp.rightResult = objA.rightResult
    rarray.push(tmp)
  })
  console.log(rarray)
  return rarray
}



// WEBPACK FOOTER //
// ./src/libs/tools.js